var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"editor v-input v-textarea theme--dark px-2",attrs:{"readonly":_vm.readonly,"spellcheck":false},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.emitChange($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }